import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";
const Main = lazy(() => import("../../components/settings/uploadDocSetup/main"));

const UploadDocumentSetUp= () => {
  return (
      <Suspense fallback={<CircularLoader />}>
        <Main />
      </Suspense>
  );
};

export default UploadDocumentSetUp;
